



























import { Component, Vue, Prop } from 'vue-property-decorator';
import FilterOption from '@/models/FilterOption';
import { FilterGetter } from '@/store/getters';
import { FilterAction } from '@/store/actions';
import HelperService from '@/services/HelperService';
import TileTrackerHelper from '@/helpers/TileTrackerHelper';
import HtmlDataHelper from '@/helpers/HtmlDataHelper';

@Component({
  name: 'quick-filter-chips-component',
})
export default class QuickFilterChipsComponent extends Vue {
  @Prop({
    type: Map,
    required: true,
  })
  private options: Map<string, FilterOption> | undefined;

  private helperService = HelperService;

  private tileTracker = new TileTrackerHelper(new HtmlDataHelper());

  private event = new CustomEvent('contentFiltering', {});

  private get appliedFilterOptions(): Map<string, FilterOption> {
    return this.$store.getters[FilterGetter.AppliedFilterOptions];
  }

  private handleChipClick(filterOption: FilterOption) {
    this.$store.dispatch(FilterAction.ToggleFilterOption, { filterOption });

    this.tileTracker.sendGoogleDataLayer({
      event: 'generic_event',
      event_name: 'click_filter_chip',
      click_filter_chip: {
        hit_source: 'dev_dl_ga4_hyb',
        state: filterOption.isChecked ? 'on' : 'off', // on, off, (optional: disabled)
        text: this.translatedFilter(filterOption), // Click Text / HTML of the clicked Chip
        jira: 'DA-1374', // Site Search - Quick Filter
      },
      category: 'Interaction',
      action: `Click Filter Chip ${filterOption.isChecked ? 'On' : 'Off'}`, // + On/Off/ (optional: Disabled)
      label: this.translatedFilter(filterOption), // Click Text / HTML of the clicked Chip
      eventNi: 0,
    });

    document.dispatchEvent(this.event);
  }

  private handleClearAllClick() {
    if (this.appliedFilterOptions.size > 0) {
      this.$store.dispatch(FilterAction.RemoveAllAppliedFilterOptions).then(() => {
        document.dispatchEvent(this.event);
      });
    }
  }

  private translatedFilter(filterOption: FilterOption) {
    return this.helperService.translatedFilterOption(filterOption);
  }
}
